import { Component, Inject, OnInit, Renderer2, ViewEncapsulation, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title, Meta, makeStateKey, TransferState } from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { DOCUMENT, Location, ViewportScroller } from '@angular/common';
import { distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';

import { TenderService } from './../../../tenders/_services/tender.service';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { GlobalLoaderService } from 'src/app/modules/shared/_services/global-loader.service';
import { TenderPayload } from './../../../tenders/_modals/tender-payload';
import { PARAMS } from 'src/app/_configs/params';
import { environment } from 'src/environments/environment';
import { SearchService } from 'src/app/modules/shared/_components/search-bar/search.service';
import { webSiteschemaService } from 'src/app/modules/shared/_services/website-schema.service';
import { StripMarginService } from 'src/app/modules/shared/_services/strip-margin.service';
import { PlanAccessService } from 'src/app/modules/auth/_services/plan-access.service';
import { PopupService } from 'src/app/modules/shared/_components/pricing-popup/popup.service';

import { AuthService } from 'src/app/modules/auth/_services/auth.service';

@Component({
  selector: 'app-tenders-list',
  templateUrl: './tenders-list.component.html',
  styleUrls: ['./tenders-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TendersListComponent implements OnInit, OnDestroy {

  imageBasePath: string = environment.TENDER.IMAGE_BASE_URL;
  showAllTenderByKeywords: boolean = false;
  showAllTenderByCities: boolean = false;
  showDiv: boolean = false;
  filterCount: number = 0;
  baseUrl: any = environment.TENDER.BASE_URL;
  private userSubscription!: Subscription;

  get visibleTenderByKeywords() { return this.showAllTenderByKeywords ? this.TenderByKeywords : this.TenderByKeywords?.slice(0, 5); }
  get visibleTenderByCities() { return this.showAllTenderByCities ? this.TenderByCities : this.TenderByCities?.slice(0, 5); }

  startEndDateTags: Array<any> = PARAMS.END_DATE_TAGS;
  minAmountList: Array<any> = PARAMS.MIN_AMOUNT_FILTER_LIST;
  maxAmountList: Array<any> = PARAMS.MAX_AMOUNT_FILTER_LIST;
  currentUrl: any;

  isMobileCheck: any;

  statesList: Array<any> = [];
  categoriesList: Array<any> = [];
  citiesList: Array<any> = [];
  keywordsList: Array<any> = [];
  tenderPayload: TenderPayload = new TenderPayload();
  tenders: Array<any> = [];
  TenderByKeywords: Array<any> = [];
  TenderByCities: Array<any> = [];
  authorityList: Array<any> = [];
  procurementList: Array<any> = [];

  activeTendersCount: number = 0;
  activePage: number = 1;

  activeSortkey: string = 'amount';
  isSortingValAsc: boolean = true;

  stateFilterQuery: any;
  categoryFilterQuery: any;
  citiesFilterQuery: any;
  keywordsFilterQuery: any;
  authorityFilterQuery: any;
  procurementFilterQuery: any;

  formGroup!: FormGroup;
  appliedFilters: Array<any> = [];

  oneAtATime: boolean = true;
  adsIndexArray: Array<any> = [];
  selcetedMinAmount: any;
  isChangedInFilter: boolean = false;

  humbergerTitle: string = '';
  adsDisplayed: any;
  searchResultsElement: HTMLElement | null = null;
  limit: any;

  sortByAccordion = [false];
  otherFilterAccordion = [false, false, false, false, false, false, false, false, false];

  TenderBytemplate = false;
  FilterBytemplate = false;
  SortTemplate = false;

  activeTab = 'tab1';
  stripMargin: boolean = true;

  isDropdownOpen = false;
  shouldShowTrialBanner = false;

  constructor(
    private title: Title,
    private tenderService: TenderService,
    private sharedService: SharedService,
    private globalLoaderService: GlobalLoaderService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private transferState: TransferState,
    private renderer2: Renderer2, private meta: Meta,
    @Inject(DOCUMENT) private document: any, private searchService: SearchService,
    private location: Location, private ViewportScroller: ViewportScroller,
    private webSiteschema: webSiteschemaService,
    private stripMarginService: StripMarginService,
    public planAccess: PlanAccessService,
    private popupService: PopupService,
    private authService: AuthService,
  ) {
    this.filterFormInit();
    this.checkScreenSize();
    if (this.sharedService.isBrowser) {
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  scrollTop() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  tabs: any[] = [
    { title: 'Active', active: false },
    { title: 'Archive', active: false },
  ];

  showTooltip = false;
  paramsData: any;
  thirdParams: any;
  urlSegments: any;
  secondParams: any;
  details: any;
  urlTypeSegments: any;
  resolverData: any

  private routeSub: Subscription = new Subscription();
  private searchQuerySub: Subscription = new Subscription();

  private hasResolved: boolean = false;

  scrollToTop() {
    this.ViewportScroller.scrollToPosition([0, 0]);
  }

  ngOnInit(): void {
    this.stripMarginService.stripMargin$.subscribe(
      (value) => {
        this.stripMargin = value;
      }
    );
    if (this.sharedService.isBrowser) {
      this.currentUrl = window.location.href;
    }

    this.routeSub.add(
      this.activatedRoute.paramMap.pipe(
        distinctUntilChanged(),
        switchMap(params => {
          this.paramsData = params.get('id');
          this.secondParams = params.get('second');
          this.thirdParams = params.get('third');

          this.updateUIBasedOnParams();

          setTimeout(() => this.scrollTop(), 0);
          return [];
        })
      ).subscribe()
    );

    // Subscribe to search query updates
    this.searchQuerySub = this.searchService.searchQuery$.subscribe(query => {
      if (query) {
        this.showDiv = false;
        if (!this.hasResolved) {
          this.resolveTenderList();
          this.hasResolved = true;
        }
      }
    });

    this.userSubscription = this.authService.user$.subscribe(() => {
      this.checkTrialBanner();
    });
  }

  async checkTrialBanner() {
    const info = await this.authService.getPlanAndDaysLeft();
    if (info && info.daysLeft <= 5 && info.daysLeft > 0) {
      this.shouldShowTrialBanner = true;
    }
    if (info && info.daysLeft === 0 && info.plan === 'basic') {
      this.onUpgrade();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.scrollTop(), 0);
  }

  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
    if (this.searchQuerySub) {
      this.searchQuerySub.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  private updateUIBasedOnParams(): void {
    if (['states', 'authorities', 'categories', 'keywords', 'cities', 'procurement'].includes(this.thirdParams || '')) {
      this.showDiv = true;
    } else {
      this.showDiv = false;
      switch (this.thirdParams) {
        case 'archived':
          this.tabs[1].active = true;
          this.tenderPayload.includeExpired = true;
          break;

        case 'active':
          this.tabs[0].active = true;
          this.tenderPayload.dir = 'ASC';
          this.tenderPayload.includeExpired = false;
          break;

        default:
          this.router.navigate(["page-not-found"]);
          break;
      }
      this.resolveTenderList();
    }
  }

  resolveTenderList() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      this.resolverData = rawData?.tendersListResolver;
      if (this.resolverData) {
        this.statesList = this.resolverData?.states?.data?.map((state: any) => ({ id: state.id, name: state.name, isSelected: false }));
        this.categoriesList = this.resolverData?.categories?.data?.map((category: any) => ({ id: category, name: category, isSelected: false }));
        this.citiesList = this.resolverData?.cities?.data?.map((city: any) => ({ id: city.id, name: city.name, isSelected: false }));
        this.keywordsList = this.resolverData?.keywords?.data?.map((keyword: any) => ({ id: keyword, name: keyword, isSelected: false }));
        this.authorityList = this.resolverData?.authorities?.data?.map((authority: any) => ({ id: authority.id, name: authority.name, isSelected: false }));
        this.procurementList = this.resolverData?.procurement?.data?.map((procurement: any) => ({ id: procurement, name: procurement, isSelected: false }));
        this.TenderByCities = this.resolverData?.topCities?.data;
      }
      let tendersResolver: any = rawData['tendersResolver'];
      if (tendersResolver) {
        this.TenderByKeywords = tendersResolver?.keywords?.data;
      }

      const fullUrl = this.location.prepareExternalUrl(this.location.path());
      this.urlTypeSegments = fullUrl.split('/');
      this.urlParamsChecker(this.urlTypeSegments[1]);
    });
  }

  faqId: any
  urlParamsChecker(paramKey: any) {
    this.retrieveQueryParams();

    if (this.paramsData) {
      this.paramsData = this.paramsData.replace(/-/g, ' ').replace('tenders', '').trim();
    }

    let statesValue = [];
    switch (paramKey) {
      case 'state':
        statesValue = this.filterStates(this.statesList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.statesList, this.formGroup.value.stateId, 'stateId');
        break;

      case 'all-tenders':
        if (this.paramsData && this.secondParams) {
          statesValue = this.filterStates(this.statesList);
          this.faqId = statesValue[0]?.id;
          this.selectItem(statesValue[0]?.id, true, this.statesList, this.formGroup.value.stateId, 'stateId');
          this.secondParams = this.secondParams.replace(/-/g, ' ').replace('tenders', '').trim();
          statesValue = this.filterStates(this.authorityList, this.secondParams);
          this.selectItem(statesValue[0]?.id, true, this.authorityList, this.formGroup.value.authorityId, 'authorityId');
        } else {
          // this.retrieveTenders();
        }
        break;

      case 'keywords':
        statesValue = this.filterStates(this.keywordsList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.keywordsList, this.formGroup.value.keywordsId, 'keywordsId');
        break;

      case 'authority':
        statesValue = this.filterStates(this.authorityList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.authorityList, this.formGroup.value.authorityId, 'authorityId');
        break;

      case 'procurement':
        statesValue = this.filterStates(this.procurementList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.procurementList, this.formGroup.value.procurementId, 'procurementId');
        break;

      case 'category':
        statesValue = this.filterStates(this.categoriesList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.categoriesList, this.formGroup.value.categoryId, 'categoryId');
        break;

      case 'city':
        statesValue = this.filterStates(this.statesList);
        this.faqId = statesValue[0]?.id;
        this.selectItem(statesValue[0]?.id, true, this.statesList, this.formGroup.value.stateId, 'stateId');
        this.secondParams = this.secondParams.replace(/-/g, ' ').replace('tenders', '').trim();
        const cityValue = this.filterStates(this.citiesList, this.secondParams);
        this.selectItem(cityValue[0].id, true, this.citiesList, this.formGroup.value.cityId, 'cityId');
        break;

      case 'authority-state':
        break;

      default:
        break;
    }
  }

  retrieveQueryParams() {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params[PARAMS.STATIC_PARAMS.QUERY_TYPE_SEARCH] || params.search === "") {
        if (this.planAccess.userPlan === 'basic') {
          this.onUpgrade();
        }
        this.humbergerTitle = 'Listing';
        this.viewAllSearchingApply(params);
        if (this.urlTypeSegments[1], params[PARAMS.STATIC_PARAMS.QUERY_KEY]) {
          this.retrieveTenders();
        }
        this.retrieveSeoDetailsAndApply(this.urlTypeSegments[1], params[PARAMS.STATIC_PARAMS.QUERY_KEY]);

      } else {
        this.humbergerTitle = 'Listing';
        this.retrieveSeoDetailsAndApply(this.urlTypeSegments[1], this.paramsData);
      }
    });
  }

  filterStates(list: any[], paramsData: string = this.paramsData): any[] {
    if (!list || !Array.isArray(list)) {
      return [];
    }
    if (!paramsData || typeof paramsData !== 'string') {
      return [];
    }

    const filteredList = list.filter((value: any) => {
      if (value && value.name && typeof value.name === 'string') {
        return value.name.toLowerCase() === paramsData.toLowerCase();
      } else {
        return false;
      }
    });

    // If no matching items are found, navigate to "page-not-found"
    if (filteredList.length === 0) {
      this.router.navigate(['page-not-found']);
    }
    return filteredList;
  }

  filterFormInit() {
    this.formGroup = new FormGroup({
      minAmount: new FormControl(''),
      maxAmount: new FormControl(''),
      stateId: new FormControl([]),
      categoryId: new FormControl([]),
      startDateFrom: new FormControl(null),
      startDateTo: new FormControl(null),
      endDateFrom: new FormControl(null),
      endDateTo: new FormControl(null),
      includeExpired: new FormControl(false),
      cityId: new FormControl([]),
      keywordsId: new FormControl([]),
      authorityId: new FormControl([]),
      procurementId: new FormControl([]),
    });
  }

  retrieveSeoDetailsAndApply(type: string, queryKey: string) {
    this.sharedService.retrieveSeoDetails(type, queryKey, this.secondParams).subscribe((res: any) => {
      this.details = res?.data;
      this.setMetas(this.details);
    });
  }

  searchResults: string = '';
  public highlightSearchResults(query: string): void {
    if (this.searchResultsElement) {
      let html = this.searchResultsElement.innerHTML;
      let highlightedHtml = html.replace(new RegExp(query, 'gi'), '<span class="highlight">$&</span>');
      this.searchResultsElement.innerHTML = highlightedHtml;
    }
  }

  searchTerm: string = '';
  totalPage: any;
  viewAllSearchingApply(params: any) {
    this.searchTerm = params.query;
    if (params[PARAMS.STATIC_PARAMS.QUERY_TYPE_SEARCH] === PARAMS.STATIC_PARAMS.SEARCH_TYPE_TENDERS_WITHIN_SAME_ORGANIZATION
    ) {
      this.humbergerTitle = 'Tenders Within Same Organization';
      this.tenderPayload.searchType = PARAMS.STATIC_PARAMS.ORGANIZATION;
      this.tenderPayload.searchKey = params[PARAMS.STATIC_PARAMS.SEARCH_TYPE_ORGANIZATION];
    } else {
      this.tenderPayload.page = 1;
      this.tenderPayload.searchType = params[PARAMS.STATIC_PARAMS.QUERY_TYPE_SEARCH];
      this.tenderPayload.searchKey = params[PARAMS.STATIC_PARAMS.QUERY_KEY];
    }
    this.highlightSearchResults(params.query);
  }

  retrieveTenders(params?: any) {
    // Subscribe to query params to extract page number dynamically
    this.routeSub.add(
      this.activatedRoute.queryParams.subscribe(params => {
        const page = params['page'] ? parseInt(params['page'], 10) : 1;
        this.tenderPayload.page = page; // Dynamically set the page in tenderPayload
        this.activePage = this.tenderPayload.page;
      })
    );

    if (this.tenderPayload.page > 1) {
      let links = this.renderer2.createElement('link');
      links.href += '?page=' + this.tenderPayload.page;
    }

    const TENDERS: any = makeStateKey<any>(PARAMS.STATIC_PARAMS.LISTING_PAGE_TENDERS);

    if (this.transferState.hasKey(TENDERS)) {
      let listingTendersData: any = this.transferState.get(TENDERS, {});

      this.activeTendersCount = listingTendersData.totalRecords;
      if (this.thirdParams === 'Archive' || this.tabData === 'Archive') {
        this.tabs[1].activeTendersCount = this.activeTendersCount;
      } else {
        this.tabs[0].activeTendersCount = this.activeTendersCount;
        this.tabs[1].activeTendersCount = listingTendersData.totalArchivedRecords;
      }
      this.tenders = listingTendersData?.dataList;
      this.totalPage = listingTendersData?.totalPage;
      this.transferState.remove(TENDERS);
      this.updateMetaTag(this.thirdParams);
      this.updateTenderOptions();
    } else {
      this.globalLoaderService.setLoaderState(true);
      this.tenderService.retrieveTenderListing(this.tenderPayload).pipe(
        catchError((error) => {
          return of({ code: 500 });
        })
      ).subscribe(
        (res: any) => {
          this.activeTendersCount = res?.data?.totalRecords;
          this.totalPage = res?.data?.totalPage;
          if (this.thirdParams === 'Archive' || this.tabData === 'Archive') {
            this.tabs[1].activeTendersCount = this.activeTendersCount;
          } else {
            this.tabs[0].activeTendersCount = this.activeTendersCount;
            this.tabs[1].activeTendersCount = res?.data?.totalArchivedRecords;
          }
          if (this.activeTendersCount === 0) {
            this.meta.removeTag("name='robots'");
            this.meta.addTag({ name: 'robots', content: 'noindex,follow' });
          }

          this.updateTenderOptions();

          this.tenders = res?.data?.dataList;
          this.retrieveRandomAdsIndex(this.activeTendersCount);
          if (this.sharedService.isServer) {
            this.transferState.set(TENDERS, res?.data);
          }
        },
        (error) => {
          // Handle any error that might have slipped through
          this.globalLoaderService.setLoaderState(false);
        },
        () => {
          // Ensure the loader is turned off on completion
          this.globalLoaderService.setLoaderState(false);
        }
      );

      // if (this.tenderPayload.page > 1) {
      //   let links = this.renderer2.createElement('link');
      //   links.href += '?page=' + this.tenderPayload.page;
      // }
      this.updateMetaTag(this.thirdParams);

    }
  }

  retrieveRandomAdsIndex(tenderCount: number) {
    const adsCount = Math.floor(tenderCount / 8);

    while (this.adsIndexArray.length < adsCount) {
      let random = Math.floor(Math.random() * (tenderCount - 1));
      if (this.adsIndexArray.indexOf(random) === -1 && random !== 0 && random > 5) {
        this.adsIndexArray.push(random);
      }
    }
    this.adsIndexArray.sort((a, b) => a - b);
  }

  navigate(link: any) {
    this.router.navigateByUrl('/' + link);
  }

  navigateToTender(link: string, event: MouseEvent): void {
    // Prevent default anchor behavior
    event.preventDefault();
    // Navigate using Angular's Router
    this.router.navigate([`/${link}-tenders/active`]);
  }

  changeSortingValue(key: string, value: boolean) {
    this.tenderPayload.page = 1;
    this.activeSortkey = key;
    this.tenderPayload.sortedBy = key;
    this.tenderPayload.dir = value ? 'DESC' : 'ASC';
    this.retrieveTenders();
  }

  onChangeSetMaxAmountlist(event: any) {
    this.selcetedMinAmount = Number(event?.target?.value);
    this.formGroup.patchValue({ maxAmount: '' });
  }

  selectItem(id: any, event: any, itemList: Array<any>, formArray: Array<any>, key: string) {
    const selectedItem = itemList?.find(item => item.id === id);
    if (!selectedItem) return;
    const isSelected = event?.target?.checked ?? event;
    if (isSelected) {
      formArray.push(id);
      selectedItem.isSelected = true;
    } else {
      const index = formArray.findIndex(item => item === id);
      formArray.splice(index, 1);
      selectedItem.isSelected = false;
    }

    if (key === 'keywordsId') {
      const selectedKeywords = this.keywordsList.find(keyword => keyword.id === id);
      if (!selectedKeywords) return;
      selectedKeywords.isSelected = isSelected;
    }
    this.applyFilters();
  }

  setterDatePicker(key: string, day: number) {

    let daysCount = day > 6 ? day - 1 : day;
    const currentDate = new Date();
    const adjustedDate = new Date(currentDate.setDate(currentDate.getDate() - daysCount));

    if (key === PARAMS.STATIC_PARAMS.START_DATE) {
      this.formGroup.patchValue({
        startDateFrom: adjustedDate.toISOString().split('T')[0],  // Format to 'YYYY-MM-DD'
        startDateTo: new Date().toISOString().split('T')[0],      // Format to 'YYYY-MM-DD'
      });
    } else if (key === PARAMS.STATIC_PARAMS.END_DATE) {
      this.formGroup.patchValue({
        endDateFrom: adjustedDate.toISOString().split('T')[0],    // Format to 'YYYY-MM-DD'
        endDateTo: new Date().toISOString().split('T')[0],        // Format to 'YYYY-MM-DD'
      });
    }

    // Apply filters based on updated values
    if (this.formGroup.value.startDateFrom && this.formGroup.value.startDateTo) {
      this.applyFilters();
    }

    if (this.formGroup.value.endDateFrom && this.formGroup.value.endDateTo) {
      this.applyFilters();
    }
  }

  changeInFilters(formControl: string, event: any) {
    if (event) {
      this.isChangedInFilter = true;
    }
    if (formControl === PARAMS.STATIC_PARAMS.START_DATE_FROM && event.target.valueAsDate) {
      this.formGroup.patchValue({ startDateTo: '' });
    }
    if (formControl === PARAMS.STATIC_PARAMS.END_DATE_FROM && event.target.valueAsDate) {
      this.formGroup.patchValue({ endDateTo: '' });
    }
    if (this.formGroup.value.startDateFrom && this.formGroup.value.startDateTo) {
      this.applyFilters()
    }
  }

  handlePageChange(page: number): void {
    this.retrieveTenders(); // Call the method to fetch tenders based on the new page number
  }

  applyFilters() {
    this.isChangedInFilter = false;
    let formValue: any = this.formGroup?.value;
    this.tenderPayload.minAmount = formValue.minAmount;
    this.tenderPayload.maxAmount = formValue.maxAmount;
    this.tenderPayload.stateIds = formValue.stateId;
    this.tenderPayload.keywords = formValue.keywordsId;
    this.tenderPayload.authorityIds = formValue.authorityId;
    this.tenderPayload.cityIds = formValue.cityId;
    this.tenderPayload.categoryId = formValue.categoryId;
    this.tenderPayload.procurement = formValue.procurementId;
    this.tenderPayload.startDateFrom = formValue.startDateFrom == undefined || null ? '' : this.sharedService.retrieveValidDate(formValue.startDateFrom);
    this.tenderPayload.startDateTo = formValue.startDateTo == undefined || null ? '' : this.sharedService.retrieveValidDate(formValue.startDateTo);
    this.tenderPayload.endDateFrom = formValue.endDateFrom == undefined || null ? '' : this.sharedService.retrieveValidDate(formValue.endDateFrom);
    this.tenderPayload.endDateTo = formValue.endDateTo == undefined || null ? '' : this.sharedService.retrieveValidDate(formValue.endDateTo);

    this.retrieveAppliedFilters();
    // this.retrieveTenders();
  }

  retrieveAppliedFilters() {
    this.appliedFilters = [];

    const addFilter = (list: any[], type: string, payloadIds: number[], label: string,) => {
      payloadIds.forEach((id: number) => {
        const item = list.find(item => item.id === id);
        if (item && !this.appliedFilters.some(filter => filter.type === type && filter.key === item.id)) {
          this.pushFilter({
            type: type,
            value: item?.name,
            key: item.id
          });
        }
      });
    };

    const addDateFilter = (type: string, from: string | null, to: string | null, label: string) => {
      let filter: any;

      const parseDate = (date: string | null): Date | null => {
        if (date && typeof date === 'string') {
          const parsedDate = new Date(date);
          return !isNaN(parsedDate.getTime()) ? parsedDate : null;
        }
        return null;
      };

      const formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const fromDate = parseDate(from);
      const toDate = parseDate(to);

      if (fromDate && toDate) {
        filter = {
          type: type,
          value: `${formatDate(fromDate)} - ${formatDate(toDate)}`,
          key: `${from} - ${to}`
        };
      } else if (fromDate || toDate) {
        const validDate = fromDate || toDate;
        filter = {
          type: type,
          value: `${fromDate ? 'From' : 'To'} - ${formatDate(validDate!)}`,
          key: `${from || to}`
        };
      } else {
        filter = {
          type: type,
          value: 'Invalid date',
          key: 'Invalid'
        };
      }

      if (this.appliedFilters.some((f: any) => f.type === type)) {
        this.appliedFilters = this.appliedFilters.map((f: any) => f.type === type ? filter : f);
      } else {
        this.pushFilter(filter);
      }
    };

    // States
    if (this.tenderPayload.stateIds.length > 0) {
      addFilter(this.statesList, PARAMS.STATIC_PARAMS.STATE, this.tenderPayload.stateIds, 'State');
    }

    // Cities
    if (this.tenderPayload.cityIds.length > 0) {
      addFilter(this.citiesList, PARAMS.STATIC_PARAMS.CITY, this.tenderPayload.cityIds, 'City');
    }

    // Keywords
    if (this.tenderPayload.keywords.length > 0) {
      addFilter(this.keywordsList, PARAMS.STATIC_PARAMS.KEYWORDS, this.tenderPayload.keywords, 'Keywords');
    }

    // Authority
    if (this.tenderPayload.authorityIds.length > 0) {
      addFilter(this.authorityList, PARAMS.STATIC_PARAMS.AUTHORITY, this.tenderPayload.authorityIds, 'Authority');
    }

    // Procurement
    if (this.tenderPayload.procurement.length > 0) {
      addFilter(this.procurementList, PARAMS.STATIC_PARAMS.PROCUREMENT, this.tenderPayload.procurement, 'Procurement');
    }

    // Category
    if (this.tenderPayload.categoryId.length > 0) {
      addFilter(this.categoriesList, PARAMS.STATIC_PARAMS.CATEGORY, this.tenderPayload.categoryId, 'Category');
    }

    // Amount
    if (this.tenderPayload.minAmount || this.tenderPayload.maxAmount) {
      let filter: any;
      if (this.tenderPayload.minAmount && this.tenderPayload.maxAmount) {
        filter = {
          type: PARAMS.STATIC_PARAMS.AMOUNT,
          value: `${this.tenderPayload.minAmount} - ${this.tenderPayload.maxAmount}`,
          key: `${this.tenderPayload.minAmount} - ${this.tenderPayload.maxAmount}`
        };
      } else {
        filter = {
          type: PARAMS.STATIC_PARAMS.AMOUNT,
          value: `${this.tenderPayload.minAmount ? 'MIN' : 'MAX'} - ${this.tenderPayload.minAmount || this.tenderPayload.maxAmount}`,
          key: `${this.tenderPayload.minAmount || this.tenderPayload.maxAmount}`
        };
      }
      if (this.appliedFilters.some(filter => filter.type === PARAMS.STATIC_PARAMS.AMOUNT)) {
        this.appliedFilters = this.appliedFilters.map(f => f.type === PARAMS.STATIC_PARAMS.AMOUNT ? filter : f);
      } else {
        this.pushFilter(filter);
      }
    }

    // Start Date
    if (this.tenderPayload.startDateFrom || this.tenderPayload.startDateTo) {
      addDateFilter(PARAMS.STATIC_PARAMS.START_DATE, this.tenderPayload.startDateFrom, this.tenderPayload.startDateTo, 'Opening Date');
    }

    // End Date
    if (this.tenderPayload.endDateFrom || this.tenderPayload.endDateTo) {
      addDateFilter(PARAMS.STATIC_PARAMS.END_DATE, this.tenderPayload.endDateFrom, this.tenderPayload.endDateTo, 'Closing Date');
    }

    // Include Expired
    if (this.tenderPayload.includeExpired) {
      this.pushFilter({
        type: PARAMS.STATIC_PARAMS.INCLUDE_EXPIRED,
        value: 'Include Expired',
        key: true
      });
    }

    this.retrieveTenders();
    this.updateFilterCount();
  }

  pushFilter(filter: any) {
    this.appliedFilters.push(filter);
  }

  replaceFilter(index: number, filter: any) {
    this.appliedFilters.splice(index, 1);
    this.appliedFilters.push(filter);
  }

  removeFilter(filter: any, index: number) {
    this.tenderPayload.page = 1;
    switch (filter.type) {
      case PARAMS.STATIC_PARAMS.AMOUNT:
        this.tenderPayload.minAmount = '';
        this.tenderPayload.maxAmount = '';
        this.selcetedMinAmount = 0;
        this.formGroup.patchValue({ minAmount: '' });
        this.formGroup.patchValue({ maxAmount: '' });
        break;

      case PARAMS.STATIC_PARAMS.STATE:
        const stateToRemove = this.statesList.find(state => state.id === filter.key);
        if (stateToRemove) {
          stateToRemove.isSelected = false;
          this.formGroup.value.stateId = this.formGroup.value.stateId.filter((stateId: any) => stateId !== filter.key);
          this.tenderPayload.stateIds.splice(index, 1);
        }
        break;

      case PARAMS.STATIC_PARAMS.CITY:
        const cityToRemove = this.citiesList.find(city => city.id === filter.key);
        if (cityToRemove) {
          cityToRemove.isSelected = false;
          this.formGroup.value.cityId = this.formGroup.value.cityId.filter((cityId: any) => cityId !== filter.key);
          this.tenderPayload.cityIds.splice(index, 1);
        }
        break;

      case PARAMS.STATIC_PARAMS.AUTHORITY:
        const authorityToRemove = this.authorityList.find(auth => auth.id === filter.key);
        if (authorityToRemove) {
          authorityToRemove.isSelected = false;
          this.formGroup.value.authorityId = this.formGroup.value.authorityId.filter((authorityId: any) => authorityId !== filter.key);
          const index = this.tenderPayload.authorityIds.indexOf(filter.key);
          if (index > -1) {
            this.tenderPayload.authorityIds.splice(index, 1);
          }
        }
        break;

      case PARAMS.STATIC_PARAMS.PROCUREMENT:
        const procurementToRemove = this.procurementList.find(proc => proc.id === filter.key);
        if (procurementToRemove) {
          procurementToRemove.isSelected = false;
          this.formGroup.value.procurementId = this.formGroup.value.procurementId.filter((procurementId: any) => procurementId !== filter.key);
          const index = this.tenderPayload.procurement.indexOf(filter.key);
          if (index > -1) {
            this.tenderPayload.procurement.splice(index, 1);
          }
        }
        break;

      case PARAMS.STATIC_PARAMS.CATEGORY:
        const categoryToRemove = this.categoriesList.find(categ => categ.id === filter.key);
        if (categoryToRemove) {
          categoryToRemove.isSelected = false;
          this.formGroup.value.categoryId = this.formGroup.value.categoryId.filter((categoryId: any) => categoryId !== filter.key);
          const index = this.tenderPayload.categoryId.indexOf(filter.key);
          if (index > -1) {
            this.tenderPayload.categoryId.splice(index, 1);
          }
        }
        break;

      case PARAMS.STATIC_PARAMS.KEYWORDS: const keywordToRemove = this.keywordsList.find(keyword => keyword.id === filter.key);
        if (keywordToRemove) {
          keywordToRemove.isSelected = false;
          this.formGroup.value.keywordsId = this.formGroup.value.keywordsId.filter((keywordId: any) => keywordId !== filter.key);
          this.tenderPayload.keywords.splice(index, 1);
        }
        break;

      case PARAMS.STATIC_PARAMS.START_DATE:
        this.tenderPayload.startDateFrom = '';
        this.tenderPayload.startDateTo = '';
        this.formGroup.patchValue({ startDateFrom: '' });
        this.formGroup.patchValue({ startDateTo: '' });
        break;

      case PARAMS.STATIC_PARAMS.END_DATE:
        this.tenderPayload.endDateFrom = '';
        this.tenderPayload.endDateTo = '';
        this.formGroup.patchValue({ endDateFrom: '' });
        this.formGroup.patchValue({ endDateTo: '' });
        break;

      case PARAMS.STATIC_PARAMS.INCLUDE_EXPIRED:
        this.tenderPayload.includeExpired = false;
        this.formGroup.patchValue({ includeExpired: false });
        break;

      default:
        break;
    }

    this.appliedFilters.forEach((item: any, i: number) => {
      if (item.type === filter.type && item.key === filter.key) {
        this.appliedFilters.splice(i, 1);
      }
    });

    if (this.appliedFilters.length === 0) {
      this.navigate('all-tenders/active');
    }

    this.retrieveTenders();
    this.updateFilterCount();
  }

  clearAllFilter() {
    this.tenderPayload = {
      stateIds: [],
      categoryId: [],
      cityIds: [],
      keywords: [],
      minAmount: '',
      maxAmount: '',
      sortedBy: '',
      dir: '',
      startDateFrom: '',
      startDateTo: '',
      endDateFrom: '',
      endDateTo: '',
      includeExpired: false,
      page: 1,
      searchKey: '',
      searchType: '',
      authorityIds: [],
      procurement: [],
      csvDownloadLimit: 0
    };

    this.selcetedMinAmount = 0;
    this.stateFilterQuery = '';
    this.categoryFilterQuery = '';
    this.citiesFilterQuery = '';
    this.keywordsFilterQuery = '';
    this.authorityFilterQuery = '';
    this.procurementFilterQuery = '';

    this.statesList.forEach(state => state.isSelected = false);
    this.categoriesList.forEach(category => category.isSelected = false);
    this.keywordsList.forEach(keyword => keyword.isSelected = false);
    this.authorityList.forEach(authority => authority.isSelected = false);
    this.citiesList.forEach(cities => cities.isSelected = false);
    this.procurementList.forEach(procurement => procurement.isSelected = false);

    this.formGroup.reset();
    this.formGroup.patchValue({ minAmount: '', maxAmount: '', includeExpired: false });

    this.appliedFilters = [];

    if (this.tenderPayload.searchType && this.tenderPayload.searchKey) {
      this.tenderPayload.searchKey = '';
      this.tenderPayload.searchType = '';
      this.tenderPayload.page = 1;
    }

    this.retrieveTenders();
    this.filterFormInit();
    this.updateFilterCount();
  }

  updateFilterCount() {
    this.filterCount = this.appliedFilters.length;
  }

  clickOncard(tenderId: number) {
  }

  openTenderByTemplate() {

    this.TenderBytemplate = true;
  }
  openFilterBytemplate() {
    this.FilterBytemplate = true;
  }

  openSortTemplate() {
    this.SortTemplate = true;
  }

  closeModal(TemplateName: any) {
    if (TemplateName == "TenderBytemplate") {
      this.TenderBytemplate = false;
    }
    if (TemplateName == "FilterBytemplate") {
      this.FilterBytemplate = false;
    }
    if (TemplateName == "SortTemplate") {
      this.SortTemplate = false;
    }
  }

  onAmountFilterChange() {
    if (this.formGroup.value.minAmount && this.formGroup.value.maxAmount) {
      this.applyFilters();
    }
  }

  tabData: any
  onTabSelect(selectedTab: any, tabId: any): void {
    this.tenderPayload.page = 1;
    this.activePage = 1;
    this.tabs.forEach(tab => tab.active = false);
    selectedTab.active = true;
    this.tabData = tabId;
    let newUrl;
    const [baseUrl, queryParams] = this.currentUrl.split('?');
    const urlParams = new URLSearchParams(queryParams);
    urlParams.delete('page');
    // Determine the new URL based on the tabId
    if (tabId) {
      if (tabId === 'Archive') {
        this.tenderPayload.includeExpired = true;
        this.tenderPayload.dir = 'DESC';
        if (baseUrl.endsWith('active')) {
          newUrl = baseUrl.replace(/active$/, 'archived');
        } else if (!baseUrl.endsWith('archived')) {
          newUrl = baseUrl.endsWith('/') ? baseUrl + 'archived' : baseUrl + '/archived';
        } else {
          newUrl = baseUrl;
        }
      } else {
        this.tenderPayload.dir = 'ASC';
        this.tenderPayload.includeExpired = false;
        if (baseUrl.endsWith('archived')) {
          newUrl = baseUrl.replace(/archived$/, 'active');
        } else if (!baseUrl.endsWith('active')) {
          newUrl = baseUrl.endsWith('/') ? baseUrl + 'active' : baseUrl + '/active';
        } else {
          newUrl = baseUrl;
        }
      }
      if (urlParams.toString()) {
        newUrl += '?' + urlParams.toString();
      }
      window.history.pushState({}, '', newUrl);
      this.retrieveTenders();
    }
  }

  updateMetaTag(tabCondition: any) {
    // Helper function to update meta robots tag
    const setMetaRobotsTag = (content: string) => {
      this.meta.removeTag("name='robots'");
      this.meta.addTag({ name: 'robots', content });
    };

    if (tabCondition === 'archived') {
      setMetaRobotsTag('noindex,follow');
    } else {
      if (this.tabData === 'archived') {
        if (this.tenderPayload.page > 1) {
          setMetaRobotsTag('noindex,follow');
        } else {
          setMetaRobotsTag('index,follow');
        }
      } else {
        if (this.tenderPayload.page > 1) {
          setMetaRobotsTag('noindex,follow');
        } else {
          setMetaRobotsTag('index,follow');
        }
      }
    }
  }

  setMetas(details: any) {
    if (!details) {
      return;
    }

    const title = details?.title || 'Default Title';
    const description = details?.metaDescription || 'Default Description';
    const imageUrl = "https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/Tender_Shark_logo.webp";
    const canonicalUrl = environment.TENDER.BASE_URL + this.router.url.split('?')[0].toLowerCase();

    this.title.setTitle(title);

    if (this.sharedService.isServer) {
      const links = this.renderer2.createElement('link');
      links.rel = 'canonical';
      links.href = canonicalUrl;
      this.renderer2.appendChild(this.document.head, links);

      this.meta.addTag({ name: "description", content: description });
      this.meta.addTag({ name: "og:title", content: title });
      this.meta.addTag({ name: "og:description", content: description });
      this.meta.addTag({ name: "og:site_name", content: "TenderShark" });
      this.meta.addTag({ name: "og:type", content: "website" });
      this.meta.addTag({ name: "og:url", content: environment.TENDER.BASE_URL + this.router.url });
      this.meta.addTag({ name: "og:image", content: imageUrl });

      this.meta.addTag({ name: "og:image", content: imageUrl });

      if (Array.isArray(details?.metaKeywords) && details.metaKeywords.length > 0) {
        this.meta.addTag({ name: "keywords", content: details.metaKeywords.join(', ') });
      }


      this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
      this.meta.updateTag({ name: 'twitter:site', content: '@tender_shark' });
      this.meta.updateTag({ name: 'twitter:title', content: title });
      this.meta.updateTag({ name: 'twitter:description', content: description });
      this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

      this.setBreadcrumbSchema(details);
      this.webSiteschema.setWebSiteSchema();
    }
  }

  setBreadcrumbSchema(tender: any) {
    let tag = this.renderer2.createElement('script');
    tag.type = "application/ld+json";
    tag.text = this.getBreadcrumbSchema(tender)
    this.renderer2.appendChild(this.document.head, tag);
  }

  getBreadcrumbSchema(tenders: any) {
    let schemaObj = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 0, "name": "Home", "item": environment.TENDER.BASE_URL }
      ]
    };

    if (tenders?.breadCrumb) {
      tenders.breadCrumb.forEach((breadcrumb: any, index: number) => {
        const breadcrumbLink = breadcrumb?.breadCrumbLink || this.currentUrl;
        schemaObj.itemListElement.push({
          "@type": "ListItem",
          "position": index + 1,
          "name": breadcrumb?.breadCrumbName,
          "item": breadcrumb?.breadCrumbLink ? environment.TENDER.BASE_URL + '/' + breadcrumbLink : breadcrumbLink
        });
      });
    }
    return JSON.stringify(schemaObj);
  }

  // Ui functionality
  readMore = false;
  private checkScreenSize() {
    if (this.sharedService.isBrowser) {
      if (typeof window !== 'undefined') {
        const isMobile = window.innerWidth <= 1199; // Adjust the breakpoint as needed
        if (isMobile) {
          this.limit = 100;
          this.isMobileCheck = true;
        } else {
          this.limit = 270;
          this.isMobileCheck = false;
        }
      } else {
        this.limit = 270;
        this.isMobileCheck = false;
      }
    }
  }

  toggleReadMore() {
    this.readMore = !this.readMore;
  }

  tooltipVisibility: { [key: number]: boolean } = {};
  toggleTooltip(index: any) {
    this.tooltipVisibility[index] = !this.tooltipVisibility[index];
  }

  selectTab(tab: string, event: Event) {
    event.preventDefault();
    this.activeTab = tab;
  }

  SortToggle(index: number) {
    this.sortByAccordion[index] = !this.sortByAccordion[index];
  }

  otherFilterToggle(index: number) {
    this.otherFilterAccordion[index] = !this.otherFilterAccordion[index];
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = (event.target as HTMLElement).closest('.tender-download-dropdown');
    if (!dropdownElement) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // Prevent the document click event from immediately closing the dropdown
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  tenderOptions: { label: string; value: string }[] = [];
  updateTenderOptions(): void {
    const count = this.activeTendersCount;
    const options = [];

    if (count > 0) {
      options.push({ label: 'Top 50 Tenders', value: 'top100' });
    }
    if (count > 50) {
      options.push({ label: 'Top 100 Tenders', value: 'top100' });
    }
    if (count > 100) {
      options.push({ label: 'Top 500 Tenders', value: 'top500' });
    }
    if (count > 500) {
      options.push({ label: 'Top 1000 Tenders', value: 'top1000' });
    }

    this.tenderOptions = options;
  }

  downloadTenderList(type: string): void {
    this.isDropdownOpen = false;
    const match = type.match(/top(\d+)/);
    const count = match ? parseInt(match[1], 10) : 0;

    if (count > 0) {
      this.downloadcsv(count);
    } else {
    }
  }

  downloadcsv(count: number): void {
    this.tenderPayload.csvDownloadLimit = count;

    this.sharedService.listingExport(this.tenderPayload).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/csv' });
        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = `tenders_top_${count}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => console.error('Download failed', err)
    });
  }

  onUpgrade() {
    this.popupService.openPricingPopup();
  }
}
